import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface TipoCondicaoBensList {
  id: number;
  nome: string;
}

export interface UsuarioListDto {
  id: number;
  usuarioCadastro: string;
}

export interface CategoriaListDto {
  id: number;
  nome: string;
}

export interface MarcaListDto {
  id: number;
  nome: string;
}

export interface ModeloListDto {
  id: number;
  nome: string;
}

export interface BemListagem {
  id: number;
  exbePatrimonioId: number;
  ativo: boolean;
  numeroDeSerie: string;
  dataCadastro: Date;
  usuarioCadastroId: number;
  descricao: string;

  tipoCondicaoBens: TipoCondicaoBensList;
  usuario: UsuarioListDto;
  categoria: CategoriaListDto;
  marca: MarcaListDto;
  modelo: ModeloListDto;
}

interface ApiResponse<T> {
  mensagem: string;
  dados: T;
}

@Injectable({
  providedIn: 'root'
})
export class ListagemBensService {

  private api = 'http://localhost:5283/api/Bens';

  constructor(private http: HttpClient) {}

  listarTodos(): Observable<BemListagem[]> {
    return this.http
      .get<ApiResponse<BemListagem[]>>(this.api)
      .pipe(map(res => res.dados));
  }

  listarFiltrado(
    categoriaId?: number | null,
    marcaNome?: string | null,
    modeloNome?: string | null,
    nomeUsuario?: string | null
  ): Observable<BemListagem[]> {

    let params = new HttpParams();

    if (categoriaId) {
      params = params.set('categoriaId', categoriaId.toString());
    }

    if (marcaNome && marcaNome.trim()) {
      params = params.set('marcaNome', marcaNome.trim());
    }

    if (modeloNome && modeloNome.trim()) {
      params = params.set('modeloNome', modeloNome.trim());
    }

    if (nomeUsuario && nomeUsuario.trim()) {
      params = params.set('nomeUsuario', nomeUsuario.trim());
    }

    return this.http
      .get<ApiResponse<BemListagem[]>>(`${this.api}/Filtros`, { params })
      .pipe(map(res => res.dados));
  }
}
